import { useModal } from "@ebay/nice-modal-react";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import FormBrain from "./FormBrain";

function BrainModalBody({ form }) {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    return (
        <>
            <FormBrain
                form={form}
                onSend={(e) => {
                    onClose();
                    modal.resolve(e);
                }}></FormBrain>
        </>
    );
}

export default BrainModalBody;
